import type { SxProps } from "@mui/joy/styles/types";

export const TRAINING_CARD_ACTION_GAP = 1;

export const trainingCardActionsContainerSx: SxProps = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: TRAINING_CARD_ACTION_GAP,
  rowGap: TRAINING_CARD_ACTION_GAP,
};

export const trainingCardActionSlotSx: SxProps = {
  width: 36,
  minWidth: 36,
  height: 36,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

/** Details + warning (not a single 36px icon slot — needs natural width). */
export const trainingMetaActionsSlotSx: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  flexShrink: 0,
  minWidth: 0,
  minHeight: 36,
  width: "auto",
  justifyContent: "center",
};

export const trainingActionSlotSpacerSx: SxProps = { width: 36, height: 36 };
